import type { ReactNode } from 'react';
import { isAccountantWorkspaceActive } from '../../lib/accountantAccess';
import DashboardLayout from '../layout/DashboardLayout';

interface AccountantReportLayoutProps {
  children: ReactNode;
}

/**
 * Conserva la presentación histórica de una pantalla para las empresas, pero
 * la integra al menú del portal cuando quien la consulta es un contador.
 */
export default function AccountantReportLayout({ children }: AccountantReportLayoutProps) {
  if (!isAccountantWorkspaceActive()) return children;
  return <DashboardLayout>{children}</DashboardLayout>;
}

